// extracted by mini-css-extract-plugin
export default {"formInputBox":"index_formInputBox_GS-Il","formInput":"index_formInput_Z50cu"};